import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import { createExternalRouteRef } from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

enum ExternalRoutesIds {
  chat = 'chat',
  projectChat = 'projectChat',
}

export const chatRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.chat,
  params: ['id'],
  optional: true,
});

export const projectChatRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.projectChat,
  params: ['id', 'chatId'],
  optional: true,
});

export const ExternalRoutes = {
  chat: chatRouteRef,
  projectChat: projectChatRouteRef,
};

export const bindHomeModuleChatRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(ExternalRoutes),
    convertLegacyRouteRefs({
      ...extraRoutes,
    }),
  );
};
